'use strict';

import { HistoryActivity } from "./history-activity";

export class HistorySearchResult {
  total: number;
  pages: number;
  rows: [HistoryActivity];

  static fromJson(dict: any): HistorySearchResult {
    let ret = new HistorySearchResult();
    return ret.fromJson(dict);
  }

  fromJson(dict: any): HistorySearchResult {
    this.total = dict.total || 0;
    this.pages = dict.pages || 0;
    this.rows = dict.rows || [];
    return this;
  }
}


// WEBPACK FOOTER //
// ./src/app/models/history-search-result.ts